module.exports = __webpack_public_path__ + "img/icn_video.b446fac5.svg";